import { useLocation, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertCircle, Wrench } from "lucide-react";
import * as LucideIcons from "lucide-react";
import { SEO } from "@/components/SEO";
import { findPanneBySlug } from "@/data/pannesData";
import { buildPanneSchema } from "@/data/panneSchema";
import { PanneHero } from "@/components/pannes/PanneHero";
import {
  PanneUrgentTip, PanneDiagnostic, PanneSolution,
} from "@/components/pannes/PanneDiagnostic";
import {
  PannePricing, PanneFaq, PanneLocalisation, PanneCta,
} from "@/components/pannes/PanneSections";
import { PanneNearbyCities } from "@/components/pannes/PanneNearbyCities";

export default function PannePage() {
  // Routes are static (generated via PANNES.map in App.js).
  // Extract slug directly from pathname (e.g. /ecran-casse-iphone-niort).
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\//, "");
  const panne = findPanneBySlug(slug);

  if (!panne) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center px-4">
          <AlertCircle className="h-16 w-16 text-red-600 mx-auto mb-4" />
          <h1 className="text-3xl font-bold mb-4">Panne non répertoriée</h1>
          <p className="text-slate-600 mb-6">Cette page n&apos;existe pas ou a été déplacée.</p>
          <Link to="/pannes-reparations">
            <Button>Voir toutes les pannes</Button>
          </Link>
        </div>
      </div>
    );
  }

  const Icon = LucideIcons[panne.icon] || Wrench;
  const schema = buildPanneSchema(panne);
  const description = `${panne.titleH1}. Diagnostic gratuit, intervention en ${panne.durationLabel}, garantie 6 mois. Tarifs à partir de ${panne.priceFrom} €. Mediastore Niort, spécialiste Apple certifié - 4,6/5 sur Google (212+ avis). ☎ 05 49 05 74 90`;
  const keywords = `${panne.keyword}, ${panne.titleH1.toLowerCase()}, ${panne.category} Niort, réparation ${panne.category} Niort, Mediastore Niort, diagnostic gratuit ${panne.category}`;
  const breadcrumbs = [
    { name: "Accueil", path: "/" },
    { name: "Pannes & Réparations", path: "/pannes-reparations" },
    { name: panne.titleH1, path: `/${panne.slug}` },
  ];

  return (
    <div className="min-h-screen" data-testid="panne-page">
      <SEO
        title={panne.metaTitle}
        description={description}
        keywords={keywords}
        path={`/${panne.slug}`}
        schema={schema}
        breadcrumbs={breadcrumbs}
      />

      <PanneHero panne={panne} Icon={Icon} />
      <PanneUrgentTip tip={panne.urgentTip} />
      <PanneDiagnostic symptoms={panne.symptoms} causes={panne.causes} />
      <PanneSolution solution={panne.solution} durationLabel={panne.durationLabel} />
      <PannePricing titleH1={panne.titleH1} pricing={panne.pricing} />
      <PanneFaq faqs={panne.faqs} />
      <PanneNearbyCities panne={panne} />
      <PanneLocalisation />
      <PanneCta />
    </div>
  );
}
